import { TFunction } from 'i18next';

const formatTooltipValue = (value: unknown, t: TFunction) => {
  const normalizedValue = Array.isArray(value) ? value[0] : value;
  if (
    normalizedValue === undefined ||
    normalizedValue === null ||
    normalizedValue === ''
  ) {
    return `-- ${t('pound')}`;
  }
  const numeric =
    typeof normalizedValue === 'number'
      ? normalizedValue
      : Number(normalizedValue);
  if (!Number.isFinite(numeric)) {
    return `-- ${t('pound')}`;
  }
  return `${numeric.toLocaleString()} ${t('pound')}`;
};

export default formatTooltipValue;
